/**
 * Whether the current user has a PIN for the given account (for blocking PIN creation flow).
 */

import { useQuery } from "@tanstack/react-query";
import { getCurrentUserHasPin } from "@common/lib/api/pins";
import { useAccountContext } from "@/state/providers/AccountProvider";

export function useCurrentUserHasPin(accountId: string | undefined): {
    hasPin: boolean;
    /** True once the pins/me request finished successfully (TanStack Query v5). */
    isPinStatusSuccess: boolean;
    isPinQueryError: boolean;
    refetch: () => void;
} {
    const { accountData } = useAccountContext();
    const pinsEnabled = accountData?.pins_enabled === true;
    const {
        data: hasPin = false,
        isSuccess,
        isError,
        refetch,
    } = useQuery({
        queryKey: ["current-user-has-pin", accountId],
        queryFn: () => getCurrentUserHasPin(accountId!),
        enabled: Boolean(accountId) && pinsEnabled,
        staleTime: 2 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });

    return {
        hasPin,
        isPinStatusSuccess: isSuccess,
        isPinQueryError: isError,
        refetch,
    };
}
